<div class="table-actions-wrapper flex min-h-0 flex-1 flex-col" *ngIf="!isLoading; else spinner">
    <div fxLayoutAlign="flex-start center" class="mb-12 shrink-0">
        <h3 class="my-0">{{ 'TEAMS.TITLE.PLURAL' | translate }}</h3>
    </div>

    <div class="teams-tree-wrapper" *ngIf="dataSource.data?.length; else noTeams">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <mat-tree-node *matTreeNodeDef="let node">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-16 pr-24" [attr.data-team-selected-row]="node.isSelected ? true : null">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span class="team-filter-dot mr-8">
                            <mat-icon class="circle">circle</mat-icon>
                        </span>
                        <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                            <mat-icon svgIcon="team"></mat-icon>
                        </div>
                        <h3 class="m-0">{{ node.name }}</h3>
                    </div>

                    <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(node)" *ngIf="!node.isSelected"></app-flat-button>

                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node)" *ngIf="node.isSelected"></app-white-button>
                </div>
            </mat-tree-node>

            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-16 pr-24" [attr.data-team-selected-row]="node.isSelected ? true : null">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <button mat-icon-button class="mr-8" (click)="toggleNode(node)" [attr.aria-label]="'Toggle ' + node.name">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                            <mat-icon svgIcon="team"></mat-icon>
                        </div>
                        <h3 class="m-0">{{ node.name }}</h3>
                    </div>

                    <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(node)" *ngIf="!node.isSelected"></app-flat-button>

                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node)" *ngIf="node.isSelected"></app-white-button>
                </div>

                <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                    <div *ngIf="node.isLoading" class="team-filter-loading-row">
                        <div class="team-filter-loading-item" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let item of [1, 2, 3]">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="min-w-0">
                                <div class="team-filter-loading-dot animate"></div>
                                <div class="team-filter-loading-avatar animate"></div>
                                <div class="team-filter-loading-text animate"></div>
                            </div>
                            <div class="team-filter-loading-button animate"></div>
                        </div>
                    </div>
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    </div>

    <ng-template #noTeams>
        <div class="teams-tree-wrapper users-empty-state" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="participant-view-illustration" svgIcon="team_illustration"></mat-icon>
            <h2 class="text-base mt-8 mb-0">
                {{ 'TEAMS.DIALOG.MOVE_TO.NO_TEAMS' | translate }}
            </h2>
        </div>
    </ng-template>
</div>

<ng-template #spinner>
    <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
        <div fxLayoutAlign="flex-start center" class="mb-12 shrink-0">
            <h3 class="my-0">{{ 'TEAMS.TITLE.PLURAL' | translate }}</h3>
        </div>
        <div class="teams-tree-wrapper filter-table-shimmer">
            <div class="filter-shimmer-table">
                <div class="filter-shimmer-row" *ngFor="let item of [1, 2, 3, 4, 5, 6]" fxLayout="row" fxLayoutAlign="start center">
                    <div class="filter-shimmer-avatar animate mr-12"></div>
                    <div class="filter-shimmer-line animate flex-1"></div>
                    <div class="filter-shimmer-button animate ml-16"></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
